var StepWrapper = function (_a) {
    var children = _a.children;
    return (<div className={'flex-1 flex w-full overflow-hidden'}>
      {children}
    </div>);
};
export default StepWrapper;
